import React from "react";

const SalesInputForm = ({ handleFieldChange, handleUpdateSalesItem, productName, itemFields }) => {

  return (
    <form onSubmit={handleUpdateSalesItem}>
        <h3 className="stock-heading">{productName}</h3>

        <div>
          <label htmlFor="openingStock">Opening stock</label>
          <input
            type="number"
            size="5"
            name="openingStock"
            id="openingstock"
            value={itemFields.openingStock}
            onChange={handleFieldChange}
          />
          </div>

          <div>
          <label htmlFor="numberFreebies">Number of freebies</label>
          <input
            type="number"
            size="5"
            name="numberFreebies"
            id="numberFreebies"
            value={itemFields.numberFreebies}
            onChange={handleFieldChange}
          />
          </div>

          <div>
          <label htmlFor="numberPaypal">Number of paypal sales</label>
          <input
            type="number"
            size="5"
            name="numberPaypal"
            id="numberPaypal"
            value={itemFields.numberPaypal}
            onChange={handleFieldChange}
          />
          </div>

          <div>
          <label htmlFor="closingStock">Closing stock</label>
          <input
            type="number"
            size="5"
            name="closingStock"
            id="closingStock"
            value={itemFields.closingStock}
            onChange={handleFieldChange}
          />
          </div>

          <div>
            <button className="form-button" type="submit">Update item</button>
          </div>

      </form>
  );

};

export default SalesInputForm;